// eslint-disable-next-line import/prefer-default-export
export enum EntityTypeEnum {
  main, brother, joined,
}
